import { defineMessages } from '@transcend-io/internationalization';

export const activeDataSubjectMessages = defineMessages(
  'privacy-center.containers.ActiveDataSubject.activeDataSubject',
  {
    header: {
      defaultMessage: 'I am a(n)',
      description:
        'The title of the modal for selecting between different data subject types.',
    },
  },
);
